import Records from '@/components/Records';

const RecordsPage = () => {
  return <Records />;
};

export default RecordsPage;
